import { generateBaseQueryKeysList } from '@/queries/utils';

export const HOSPITAL_CONTACTS_KEYS = {
  main: 'hospital-contacts',
};

export const hospitalContactsQueryKeys = generateBaseQueryKeysList(HOSPITAL_CONTACTS_KEYS.main);
